import { useState } from "react";
import { Play } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Magnetic } from "@/components/Magnetic";
import VideoTour from "@/components/VideoTour";
import { scrollToId } from "@/lib/scroll";

export default function ClosingCTA() {
  const [tourOpen, setTourOpen] = useState(false);

  return (
    <section className="relative overflow-hidden border-y border-gold/15 py-24 md:py-28" data-testid="closing-cta-section">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(11,61,46,0.55),transparent_60%)]" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-5 md:grid-cols-2 md:px-8">
        <Reveal>
          <p className="font-script text-3xl text-gold-light md:text-4xl">ready when you are</p>
          <h2 className="mt-3 font-serif text-4xl font-medium leading-[1.08] tracking-tight text-white md:text-5xl" data-testid="closing-cta-heading">
            Let's build something <span className="italic text-gold">extraordinary</span> together.
          </h2>
          <p className="mt-5 max-w-md text-sm font-light leading-relaxed text-white/65 md:text-base">
            The kitchen is ready. Are you? Take the full cinematic walkthrough, then book a private tour of the facility.
          </p>
          <Magnetic className="mt-9">
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollToId("#contact"); }}
              data-testid="closing-cta-button"
              className="inline-flex rounded-full bg-gold px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-black transition-colors duration-300 hover:bg-gold-light"
            >
              Partner With Us
            </a>
          </Magnetic>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative overflow-hidden rounded-2xl border border-gold/25 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)]" data-testid="cta-video-panel">
            <button
              onClick={() => setTourOpen(true)}
              className="group relative block w-full text-left"
              data-testid="cta-video-play-button"
              aria-label="Open full-screen facility walkthrough"
            >
              <img
                src="/assets/video/hero-poster.jpg"
                alt="Royal Express facility walkthrough video — Dubai Investment Park cloud kitchen"
                loading="lazy"
                className="aspect-video w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/35 transition-colors duration-500 group-hover:bg-black/20" aria-hidden="true" />
              <span className="absolute left-1/2 top-1/2 flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-gold/60 bg-black/50 text-gold shadow-[0_0_36px_rgba(212,175,55,0.35)] backdrop-blur-md transition-all duration-500 group-hover:scale-110 group-hover:bg-gold group-hover:text-black">
                <Play size={26} className="ml-1" fill="currentColor" />
              </span>
              <span className="absolute bottom-5 left-5 rounded-sm border border-gold/50 bg-black/70 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-gold backdrop-blur-md">
                Full Walkthrough · 6 Zones · 1 Min
              </span>
            </button>
          </div>
        </Reveal>
      </div>
      <VideoTour open={tourOpen} onClose={() => setTourOpen(false)} />
    </section>
  );
}
